
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
	Web and Mobile Application Designer   
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience : </h3>
                <p> <span class="step_no">1</span> Regular B.E/ B. Tech / M. Tech / BSC / MSc / MCA degree in Computer Science / Information Technology / Electronics and Communication Engineering or any degree with specialization in computers or equivalent with 2 + years of Experience in designing responsive web and Mobile Templates.</p>
				
               <!-- <p> <span class="step_no">2</span>Two (2) years of experience with multimedia/audio-video/production and post-production using a professional news non-linear video editing system such as Final Cut Pro, Avid or Premiere Pro.</p>
                
                
               <p> <span class="step_no">3</span>Demonstrated effective oral and written communication skills and ability to Determine organizational and analytical skills. 
               </p>
               <p> <span class="step_no">4</span>Capacity to work both independently and as a member of a team.</p> -->
               <!--<p> <span class="step_no">5</span>Experience of working towards creation of/leading incubation centres. start-ups would be preferred  </p>
				<p> <span class="step_no">6</span>Experience in Policy facilitation, project management will be preferred. </p>
				<p> <span class="step_no">7</span>Special skill required (if applicable): Excellent with MS Office, Excel, Power Point</p>
				<p> <span class="step_no">8</span>Details of Competencies required for the position: Competency to perform advisory role, stakeholder management and policy analysis to support entrepreneurial division for MSDE</p>
				<p> <span class="step_no">9</span>Key Performance Indicators (KPIs):</p>
				<p>	•	Capacity to function as part of a multi disciplinary team.</p>
				<p>	•	Formulation of Project Proposals as per MSDE mandate</p>
				<p>	•	Pro-actively interact with key stake-holders, Ministries, State Governments, UN agencies, Corporate Sector etc. </p>-->
				

              </div>
            </div>
          </div>
          <!-- feature box close -->

          <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>PREFERRED:</h3>
        <p> <span class="step_no">1</span>Excellent Knowledge of HTML5, CSS3, Responsive design, Bootstrap, Dreamweaver, Adobe Photoshop, illustrator, Corel Draw etc. </p>
        <p> <span class="step_no">2</span>Create wireframes, storyboards, user flows, process flows Candidate should have creative and analytic mindset.</p>
        <p> <span class="step_no">3</span>Experience in designing landing pages, emails, mobile-first websites designed by you using Photoshop </p>
		<p> <span class="step_no">4</span>Designing and developing responsive designs. </p>
        <p> <span class="step_no">5</span>Knowledge in PSD to HTML conversions.</p>
		<p> <span class="step_no">6</span>Knowledge on Plug-in's in Bootstrap 3.0 etc.,</p>
		<p> <span class="step_no">7</span>Portfolio of banner & carousel images for ads, social media, and blogs designed by you using Photoshop/Illustrator.</p>
		<p> <span class="step_no">8</span>Experience in API integrations developed in multiple technologies be it in Java, Python, PHP, or any 3rd party APIs</p>
		
       </div>
    </div>
  </div>
  
  
  <!-- feature box close -->

<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Technologies</h3>
        <p> <span class="step_no">1</span>Strong experience in modern HTML/CSS/JS Techniques, including </p>
        <p> HTML Slicing</p><br>
        <p> CSS pre-processors e.g., less/sass </p><br>
        <p> frameworks e.g., Bootstrap, jQuery, Angular/Vue, Node JS</p><br>
        <p> <span class="step_no">2</span>Front-end coding conventions e.g., SEO, Open graph, HTTP Response codes, etc</p>
        <p> <span class="step_no">3</span>Exposure on SQL Databases</p>
    <!--<p> <span class="step_no">5</span>Experience in developing Functions and Triggers</p>
    <p> <span class="step_no">6</span>Experience in Management Information Systems (MIS)</p>-->
    
       </div>
    </div>
  </div>
  

<!-- feature box close -->

          <!--feature box begin-->
          <div class="col-md-12 feature-box mb40 sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-history"></i>
              <div class="text para_cls">
                <h3>Responsibilities</h3>
                <p> <span class="step_no">1</span>Responsibilities creating website designs producing sample sites, with recent technological and software developing skills and expertise in appropriate software programming languages such as HTML, JavaScript, CSS, jQuery, Bootstrap, Angular JS.</p>
                <p> <span class="step_no">2</span>Good understanding and experience about cross browser compatibility, usability, and accessibility design issues</p>
                <p> <span class="step_no">3</span>Should have experience in responsive UI design, capable of developing pages considering both desktop & mobile devices</p>
                <p> <span class="step_no">4</span>Able to Design and develop world-class Web/UI/UX design.</p>
                <p> <span class="step_no">5</span>Excellent design sense, including choice of images, illustrations, colour, and typography </p>
                <p> <span class="step_no">6</span>Good Knowledge in building web design templates using photoshop or relevant tools.</p>
                <p> <span class="step_no">7</span>To be successful in this role, you will need to have excellent visual design skills and be proficient in graphic design software such as Adobe Photoshop and Adobe Illustrator.</p>
                <p> <span class="step_no">8</span>Design and optimize website/web pages for search engines, must have qualities and ability of Search Engine Marketing/Internet Marketing, Social Media Marketing (Facebook, YouTube, etc.)</p>
                <p> <span class="step_no">9</span>Proven work experience as a Web Designer.</p>
                <p> <span class="step_no">10</span>SEO, SEM, Social Media Marketing and Analytics tools and reporting. </p>
                <p> <span class="step_no">11</span>Ability to work on multiple projects & should interact with clients.</p>
                <p> <span class="step_no">12</span>Think creatively and develop new design concepts, graphics, and layouts. </p>
                <!-- <p> <span class="step_no">13</span>Knowledge of best practices in database management. </p>
                <p> <span class="step_no">14</span>Advanced analytical, leadership, and problem-solving skills. </p> -->
               </div>
            </div>
          </div>
       <!-- feature box close -->
  


  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Skills & Requirements</h3>
        <p> <span class="step_no">1</span>Hands on experience in Core PHP, Laravel/ Node JS.</p>
        <p> <span class="step_no">2</span>Familiarity with node.js server environment.Familiarity with JavaScript frameworks such as Node JS / Angular </p>
        <p> <span class="step_no">3</span>Familiarity with database technology such as MySQL and MongoDB.</p>
        <p> <span class="step_no">4</span>Experience with HTML5 CSS3 frameworks such as bootstrap.</p>
        <p> <span class="step_no">5</span>Experience with web services API integration (Rest, JSON, XML).</p>
        <p> <span class="step_no">6</span>Solid & deep understanding of the full web technology stack (e.g., HTTP, cookies, headers, caching, asset pipelines)</p>
        <p> <span class="step_no">7</span>Solid understanding of version control systems such as Git and bitbucket</p>
		    <p> <span class="step_no">8</span>Experience using different development methodologies including Scrum, and/or Agile, and test-driven development</p>
        <p> <span class="step_no">9</span>Disciplined approach to software engineering best practices (e.g., unit testing, code reviews, design documentation, quality assurance)</p>
		    <p> <span class="step_no">10</span>Must be experienced with Payment Gateway integrations. </p>
        <p> <span class="step_no">5</span> Experience in working with agile methodologies. </p>
       </div>
    </div>
  </div> -->
  <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 40,000/-  to 50,000/- Per month   </p>
		<!--<p> <span class="step_no">2</span> Rs. 1,00,000/- per month (consolidated pay) for 3+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>-->


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Other terms and conditions:</h3>
        <p> <span class="step_no">1</span>All candidates should mail their resume and their showreels to nimirecruitment@gmail.com on or before 09th December 2022. </p>
        <p> <span class="step_no">2</span>The Candidate has to mention for which job profile He/She is applying at the top of the resume they are submitting. If not, the resume will automatically get rejected. </p>
        <p> <span class="step_no">3</span>The appointments to the above posts are purely contractual and will terminate automatically on the expiry of the contract period. </p>
        <p> <span class="step_no">4</span>The place of posting will be at Chennai only. On occasions, the job may involve touring also.</p>
        <p> <span class="step_no">5</span>Candidates selected for recruitment shall be prepared to join on short notice. </p>
		<p> <span class="step_no">6</span>Candidate must bring their show reel (works) at the time of interview</p>
        <p> <span class="step_no">7</span>Candidate attending the skill test & interview would not be paid TA/DA by NIMI</p>
        <p> <span class="step_no">8</span>Candidate who fulfils the required eligibility conditions shall bring their original certificate and other documents on the date and time mentioned above in support of their claim in age, educational qualifications, experience etc.</p>
        <!--<p> <span class="step_no">9</span> Planning and coordination of innovation events, trainings, national awards, workshops, conferences, visits, and exchange programme etc.</p>-->
        
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Age</h3>
        <p><span class="step_no">1</span>Chennai</p>-->
		<!--<p>Up to 35 years</p>
	
      </div>
    </div>
  </div>-->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 09th December 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Period of Contract </h3>
        <!--<p><span class="step_no">1</span>Chennai</p>-->
		<p>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year. The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of NIMI shall be final in this regard.</p>
	
      </div>
    </div>
  </div>

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>01- Post   chennai </p>
		<!--<p><span class="step_no">1</span>04 (Four)at NIMI, Chennai</p>-->
	
      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Short listed candidates will be called for Computer test followed by Interview. </p>
        <!--<p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
        <p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>-->

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>-->
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>












